<template>
  <v-card>
    <v-data-table
      :headers="headers_responsabili"
      :items="items_responsabili.filter((r) => r.validita != -1)"
      :single-expand="true"
      :expanded.sync="expanded_responsabili"
      fixed-header
      height="70vh"
      item-key="id_personale"
      show-expand
      class="elevation-1 pt-0"
    >
      <!-- Titolo del primo livello della tabella (responsabili) -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Responsabili di Reparto
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickAggiungiResponsabile()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Responsabile</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
      </template>

      <!-- Bottone di modifica del responsabile -->
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickModificaResponsabile(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica Responsabile</span>
        </v-tooltip>
      </template>

      <!-- Bottone di eliminazione del responsabile -->
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickEliminaResponsabile(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error"> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Elimina Responsabile</span>
        </v-tooltip>
      </template>

      <!-- Drill down dei membri del team -->
      <template v-slot:expanded-item="{ headers, item }">
        <td
          class="pa-0"
          style="background-color: white"
          :colspan="headers.length"
        >
          <v-data-table
            class="elevation-3"
            :headers="headers_team"
            :items="item.personale ? item.personale.filter((m) => m.validita != -1):[]"
          >
            <!-- Titolo del seconndo livello della tabella (membri) -->
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text"> Team </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickAggiungiMembro(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi Membro</span>
                </v-tooltip>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <!-- Bottone di modifica del membro -->
            <template v-slot:[`item.modifica`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickModificaMembro(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary"> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Elimina Membro</span>
              </v-tooltip>
            </template>

            <!-- Bottone di eliminazione del membro -->
            <template v-slot:[`item.elimina`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickEliminaMembro(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Elimina Membro</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>

    <!-- Dialog della modifica del membro -->
    <v-dialog v-model="dialog_edit_membro">
      <ModificaMembro
        @click_chiudi="handleCloseEditMem"
        :items_id_usati="items_id_usati"
        @salvate_modifiche="handleSaveMem"
        :utente_sel="membro_sel_edit"
        :visible="dialog_edit_membro"
      />
    </v-dialog>

    <!-- Dialog della modifica del responsabile -->
    <v-dialog v-model="dialog_edit_responsabile">
      <ModificaResponsabile
        @click_chiudi="handleCloseEditRes"
        :items_id_usati="items_id_usati"
        @salvate_modifiche="handleSaveRes"
        :utente_sel="responsabile_sel_edit"
        :visible="dialog_edit_responsabile"
      />
    </v-dialog>

    <!-- Dialog di conferma eliminazione membro -->
    <v-dialog v-model="conferma_elimina_membro" persistent width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Eliminazione Membro
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 20px">
            Confermi la rimozione di questo membro dal team in cui era inserito?
          </span>

          <v-divider class="my-5"></v-divider>

          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn class="mr-5" @click="clickBackDeleteMem">
                  <v-icon color="error" large>mdi-close</v-icon>
                </v-btn>
                <v-btn class="mr-5" @click="clickOkDeleteMem">
                  <v-icon color="success" large> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione responsabile -->
    <v-dialog v-model="conferma_elimina_responsabile" persistent width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Eliminazione Responsabile
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 20px">
            Confermi la rimozione di questo responsabile e del suo team?
          </span>

          <v-divider class="my-5"></v-divider>

          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn class="mr-5" @click="clickBackDeleteRes">
                  <v-icon color="error" large>mdi-close</v-icon>
                </v-btn>
                <v-btn class="mr-5" @click="clickOkDeleteRes">
                  <v-icon color="success" large> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import _ from "lodash";
import Membro from "@/classes/EMMembroTeam.js";
import ModificaMembro from "@/components/PRODUCTION/Impostazioni/ModificaMembro.vue";
import ModificaResponsabile from "@/components/PRODUCTION/Impostazioni/ModificaResponsabile.vue";
import Responsabile from "@/classes/EMResponsabileTeam.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestioneReparto",
  components: { ModificaMembro, ModificaResponsabile, SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      membro_sel_edit: new Membro(),
      responsabile_sel_edit: new Responsabile(),

      // Modal
      conferma_elimina_membro: false,
      conferma_elimina_responsabile: false,
      dialog_edit_membro: false,
      dialog_edit_responsabile: false,
      overlay: false,

      // Array
      expanded_responsabili: [],
      headers_responsabili: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_team: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      items_responsabili: [],
      items_id_usati: [],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickAggiungiMembro(arg) {
      this.membro_sel_edit = new Membro();
      this.membro_sel_edit.id_padre = arg.id_personale;
      this.dialog_edit_membro = true;
    },
    clickAggiungiResponsabile() {
      this.dialog_edit_responsabile = true;
      this.responsabile_sel_edit = new Responsabile();
    },
    clickBackDeleteMem() {
      // Nascondo il dialog di conferma
      this.conferma_elimina_membro = false;

      // Cancello il puntatore all'oggetto che volevo eliminare
      delete this.membro_sel_delete;
    },
    clickBackDeleteRes() {
      // Nascondo il dialog di conferma
      this.conferma_elimina_responsabile = false;

      // Cancello il puntatore all'oggetto che volevo eliminare
      delete this.responsabile_sel_delete;
    },
    clickEliminaMembro(arg) {
      this.conferma_elimina_membro = true;

      // Istituisco un puntatore all'oggetto selezionato
      this.membro_sel_delete = new Membro(arg);
    },
    clickEliminaResponsabile(arg) {
      this.conferma_elimina_responsabile = true;

      // Istituisco un puntatore all'oggetto selezionato
      this.responsabile_sel_delete = new Responsabile(arg);
    },
    clickModificaMembro(arg) {
      this.membro_sel_edit = new Membro(arg);
      this.dialog_edit_membro = true;
    },
    clickModificaResponsabile(arg) {
      this.responsabile_sel_edit = new Responsabile(arg);
      this.dialog_edit_responsabile = true;
    },
    clickOkDeleteMem() {
      // Chiudo il dialog di conferma
      this.conferma_elimina_membro = false;

      this.membro_sel_delete.validita = 0;

      const membro_sel_delete_tmp = _.cloneDeep(this.membro_sel_delete);

      delete this.membro_sel_delete;

      // Compongo la request e gestisco la response
      let request = {
        method: "PUT",
        controller: "Magazzino",
        richiesta: {
          action: "setpersonale",
          token: localStorage.user_token,
          team: [membro_sel_delete_tmp],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;

            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Risorsa rimossa con successo!"
            );

            // Aggiorno i dati della tabella
            this.getTeamAll();
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore critico nella comunicazione col server."
          );
        });
    },
    clickOkDeleteRes() {
      // Chiudo il dialog di conferma
      this.conferma_elimina_responsabile = false;

      this.responsabile_sel_delete.validita = 0;

      // Faccio un oggetto temporaneo da modificare
      const responsabile_tmp = _.cloneDeep(this.responsabile_sel_delete);
      const arr_tmp = [];

      // Cancello il puntatore che non mi serve più
      delete this.responsabile_sel_delete;

      // Inserisco i sottoposti del responsabile nell'array della gente da eliminare
      responsabile_tmp.personale.forEach((m) => {
        m.validita = 0;
        arr_tmp.push(Object.assign(m));
      });

      /* Cancello gli annidamenti dal responsabile_tmp
       * per non spedire al BE strutture inutili. */
      delete responsabile_tmp.personale;

      // Inserisco anche il responsabile nell'array della gente da eliminare
      arr_tmp.unshift(Object.assign(responsabile_tmp));

      let request = {
        method: "PUT",
        controller: "Magazzino",
        richiesta: {
          token: localStorage.user_token,
          action: "setpersonale",
          team: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Risorsa rimossa con successo!"
            );

            // Aggiorno i dati della tabella
            this.getTeamAll();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore nella comunicazione col server, codice: ${res.status}.`
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore critico nella comunicazione col server."
          );
        });
    },
    getTeamAll() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getteamall",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Resetto l'array
            this.items_responsabili = new Array();
            this.items_id_usati = [];

            // Valorizzo i dati
            res.data.result.capobarca.forEach((r) => {
              this.items_responsabili.push(new Responsabile(r));
              this.items_id_usati.push(r.id_personale);
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nello scambio di dati col server."
            );
          }
        })
        .catch((err) => {
          if (err) {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore nello scambio di dati col server."
            );
          }
        });
    },
    handleCloseEditMem() {
      this.dialog_edit_membro = false;
    },
    handleCloseEditRes() {
      this.dialog_edit_responsabile = false;
    },
    handleSaveMem() {
      this.dialog_edit_membro = false;

      // Aggiorno la tabella del team.
      this.getTeamAll();
    },
    handleSaveRes() {
      this.dialog_edit_responsabile = false;

      // Aggiorno la tabella del team.
      this.getTeamAll();
    },
  },
  created() {},
  mounted() {
    this.getTeamAll();
  },
};
</script>
<style scoped>
</style>